'use client';

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider, createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { colorDarkest, copyColor, copyFontFamily, copyLineHeight } from './selectors';
import { brandFonts } from './fonts';
import { ModeProvider, tokenMapping } from './ModeProvider';
import { default as token } from './getToken';
const Reset = createGlobalStyle`
  ${normalize};

  html {
    color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.id === 'nib' ? token('theme.color.fg', colorDarkest) : token('theme.color.fg', copyColor);
}};
    font-family: ${copyFontFamily};
    font-weight: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.copy.fontWeight;
}};
    line-height: ${copyLineHeight};
    
    /* Not setting font-size because we want 16px */
    font-display: swap;

    @media (prefers-reduced-motion: no-preference) {
      scroll-behavior: smooth;
    }
  }
`;
/**
 * Global styles for all modes of a brand
 */
const AllModesForBrand = createGlobalStyle`
  ${props => {
  const brand = props.theme.id;
  const modes = tokenMapping[brand] || {};
  return Object.keys(modes).map(mode => modes[mode]);
}}
`;
const Theme = _ref3 => {
  let {
    children,
    theme,
    mode
  } = _ref3;
  const themeWithFormMode = mode ? {
    ...theme,
    mode
  } : theme;
  const BrandFonts = brandFonts[theme.id];
  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: themeWithFormMode,
    children: /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Reset, {}), /*#__PURE__*/_jsx(AllModesForBrand, {}), BrandFonts && /*#__PURE__*/_jsx(BrandFonts, {}), /*#__PURE__*/_jsx(ModeProvider, {
        mode: "default",
        children: children
      })]
    })
  });
};
Theme.displayName = 'Theme';
export default Theme;
export { Reset as CSSReset };
export * from './selectors';
export * from './brands';
export * from './types';
export * from './common';
export * from './utils';
export * from './ModeProvider';
export { default as token } from './getToken';